const { request } = require('./request');
const baseURL = "/api/oauth";

export const getOAuthClients = () => {
  return request(`${baseURL}/clients`, {
    method: 'GET',
  });
};

export const getOAuthClient = (clientId) => {
  return request(`${baseURL}/clients/${clientId}`, {
    method: 'GET',
  });
};

export const createOAuthClient = (clientData) => {
  return request(`${baseURL}/clients`, {
    method: 'POST',
    json: clientData,
  });
};

export const updateOAuthClient = (clientId, clientData) => {
  return request(`${baseURL}/clients/${clientId}`, {
    method: 'PUT',
    json: clientData,
  });
};

export const deleteOAuthClient = (clientId) => {
  return request(`${baseURL}/clients/${clientId}`, {
    method: 'DELETE',
  });
};